import { css } from 'styled-components'

export const backgroundBlur = css`
  background: ${({ theme }) => theme.background.secondary + 'CC'} !important;
  backdrop-filter: blur(20px) !important;
`
